import React, { useState } from 'react';
import { Button, Checkbox, Slider } from 'antd';
import styles from './Effects.module.scss';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

type Props = {
  contrast: number;
  brightness: number;
  saturation: number;
  setContrast: (value: number) => void;
  setBrightness: (value: number) => void;
  setSaturation: (value: number) => void;
  onSaveFilters: (contrast: number, brightness: number, saturation: number, applyToAll: boolean) => void;
  onResetFilters: () => void;
  setShowImageEffects: (value: boolean) => void;
};

const Effects = ({
  contrast,
  setContrast,
  brightness,
  setBrightness,
  saturation,
  setSaturation,
  onSaveFilters,
  onResetFilters,
  setShowImageEffects
}: Props) => {
  const [applyToAll, setApplyToAll] = useState(false);

  const onApplyToAllChange = ({ target: { checked } }: CheckboxChangeEvent) => {
    setApplyToAll(checked);
  };

  const saveClicked = () => {
    onSaveFilters(contrast, brightness, saturation, applyToAll);
    setShowImageEffects(false);
  };

  return (
    <div className={styles.effectsContainer}>
      <div className={styles.effectsWrapper}>
        <div className={styles.effectItem}>
          <label>Contrast:</label>
          <Slider tooltipVisible={false} step={0.05} value={contrast} onChange={value => setContrast(value as number)} min={-1} max={1} />
        </div>
        <div className={styles.effectItem}>
          <label>Brightness:</label>
          <Slider tooltipVisible={false} step={0.05} value={brightness} onChange={value => setBrightness(value as number)} min={-1} max={1} />
        </div>
        <div className={styles.effectItem}>
          <label>Saturation:</label>
          <Slider tooltipVisible={false} step={0.05} value={saturation} onChange={value => setSaturation(value as number)} min={-1} max={1} />
        </div>
        <div>
          <Checkbox checked={applyToAll} onChange={onApplyToAllChange}>
            Apply to sequence
          </Checkbox>
        </div>
        <div className={styles.actionsItem}>
          <Button style={{ marginRight: '10px' }} type='default' onClick={onResetFilters}>
            Reset filters
          </Button>
          <Button title='' type='primary' onClick={saveClicked}>
            Save filters
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Effects;
